/* eslint-disable import/first, import/newline-after-import */

import EezyStimulusApplication from 'packs/eezy-stimulus'; // eslint-disable-line import/order

import SearchController from 'controllers/search-controller';
EezyStimulusApplication.register('ez-search', SearchController);

import SearchFormController from 'components/search/search-form/search-form-controller';
EezyStimulusApplication.register('search-form', SearchFormController);
